module.exports = __webpack_public_path__ + "static/media/slideshow (13).6b6ba8d1.png";